class CollectionSidebar {
  constructor() {
    this.toggle = document.querySelector('[data-collection-sidebar-toggle]');
    this.nav = document.querySelector('[data-collection-sidebar-nav]');
    if (!this.toggle || !this.nav) return;

    this.toggle.addEventListener('click', () => {
      const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
      this.toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      this.nav.classList.toggle('is-open', !expanded);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CollectionSidebar();
});
